import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const DropdownArrowUpIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.5858 15C17.4767 15 17.9229 13.9229 17.2929 13.2929L12.7071 8.70711C12.3166 8.31658 11.6834 8.31658 11.2929 8.70711L6.70711 13.2929C6.07714 13.9229 6.52331 15 7.41421 15L16.5858 15Z"
          fill="black"
        />
      </svg>
    )
  },
)
